import { Link } from "react-router-dom";
const NavBarMenu = () => {
    let pathName = window.location.pathname;
    console.log(pathName);   
      

    return <nav className="navbar navbar-expand-lg bg-body-tertiary rounded" aria-label="Twelfth navbar example">
        <div className="container-fluid">
            <button className="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbarsExample10" aria-controls="navbarsExample10" aria-expanded="false" aria-label="Toggle navigation"> <span className="navbar-toggler-icon"></span>
            </button>
            <div className="navbar-collapse justify-content-md-center collapse" id="navbarsExample10">
                <ul className="navbar-nav">
                    <li className="nav-item">                        
                        <Link className="nav-link {pathName==='/home' ? 'Active':''}" aria-current="page" to="/">Home</Link>
                    </li>                    
                    <li className="nav-item {pathName==='/home-services' ? 'Active':''}"><Link className="nav-link" to="/home-services">Services</Link>
                    </li>
                    <li className="nav-item {pathName==='/hotels' ? 'Active':''}"><Link className="nav-link" to="/hotels">Hotels</Link>
                    </li>
                    {/* <li class="nav-item"> <a class="nav-link disabled" aria-disabled="true">Disabled</a>
                    </li> */}
                    {/* <li class="nav-item dropdown"> <a class="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown" aria-expanded="false">Dropdown</a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" href="#">Action</a></li>
                            <li><a class="dropdown-item" href="#">Another action</a></li>
                            <li><a class="dropdown-item" href="#">Something else here</a></li>
                        </ul>
                    </li> */}
                </ul>
            </div>
        </div>
    </nav>
    
}
export default NavBarMenu;